import React from 'react'

export function ModalBody({
  children,
}: {
  readonly children: React.ReactNode
}) {
  return <p className={'text-body text-center mb-12'}>{children}</p>
}
